import React, { FC } from 'react';

import { Grid, TableCell, TableHead, TableRow } from '@material-ui/core';

import { useAssignResultsState } from '../AssignResults/Context/AssignResults.context';
import AwardsActionsButtons from './Components/AwardsActionsButtons';

const ResultsTableHead: FC = () => {
  const { results, selectedCombination, teamResults } = useAssignResultsState();

  if (!selectedCombination) {
    return <></>;
  }

  return (
    <TableHead>
      <TableRow className="table-subheader">
        <TableCell colSpan={4}>
          <>
            <p className="flightName">
              {selectedCombination.flight ? selectedCombination.flight.name : 'All flights'}
            </p>

            {results.length > 0 || teamResults.length > 0 || (
              <p className="noResults">There are no results or awards for this selection</p>
            )}
          </>
        </TableCell>

        {(results.length > 0 || teamResults.length > 0) && (
          <TableCell colSpan={3}>
            <Grid className="grid" container={true} spacing={8}>
              <AwardsActionsButtons />
            </Grid>
          </TableCell>
        )}
      </TableRow>

      {(results.length > 0 || teamResults.length > 0) && (
        <TableRow className="table-header">
          <TableCell>
            {selectedCombination.format.format.prefix === 'stroke' ? 'Pos' : 'Hole'}
          </TableCell>

          <TableCell>Player</TableCell>

          <TableCell colSpan={2}>Score</TableCell>

          <TableCell>Points</TableCell>

          <TableCell>Scrip</TableCell>

          <TableCell>Cash</TableCell>
        </TableRow>
      )}
    </TableHead>
  );
};

export default ResultsTableHead;
